
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'HistoryFundsTable'
})
export default class extends Vue {
  filters: any = {
    email: null,
    firstName: null,
    lastName: null,
    dateRange: null,
    amount: null
  }
  pagination = {
    page: 1,
    limit: 10
  }

  handleSearch() {
    this.$emit('filters', this.filters)
  }
}
